// extracted by mini-css-extract-plugin
module.exports = {"row":"upload-box_row__2AWv_","text":"upload-box_text__RCQbp","icon":"upload-box_icon__2_993","button":"upload-box_button__2mFsd"};